import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { Observable } from 'rxjs';
import { UserService } from '../user/user.service';
import { UserBasicInfo } from '../models/user/user-models';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { CaseService } from '../cases/case.service';
import { RoleClaimValues } from '../auth/identity';
import { TranslocoDirective } from '@jsverse/transloco';
import { LanguageFormComponent } from '../i18n/language-form/language-form.component';
import { MatButton } from '@angular/material/button';
import { MatTooltip } from '@angular/material/tooltip';
import { AsyncPipe } from '@angular/common';

@UntilDestroy()
@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [TranslocoDirective, LanguageFormComponent, MatButton, MatTooltip, AsyncPipe]
})
export class LoginComponent{
	private readonly _userProfileService = inject(UserService);
	private readonly _oidcService = inject(OidcSecurityService);
	private readonly _caseService = inject(CaseService);


	userBasicInfo$!: Observable<UserBasicInfo | null>;

	constructor()
	{
		this.userBasicInfo$ = this._userProfileService.basicInfo$;
	}

	isAdmin(user: UserBasicInfo): boolean {
		if (user.roles && user.roles.indexOf(RoleClaimValues.globalAdministrator) >= 0) {
			return true;
		}
		return false;
	}

	whipe() {
		this._caseService.deleteAllUserResponses().subscribe(() => {
			localStorage.removeItem("assessment_stage");
			window.location.reload();
		});
	}

	logout() {
		this._oidcService.logoff().subscribe();
	}
}
